import { V4 } from '@/utils/math';
import { Globe, path } from "@hscmap/stellar-globe";
import { AreaType } from "..";

export class AreaRenderer extends path.Renderer {
  constructor(readonly globe: Globe, public area: AreaType, public color: V4) {
    super(globe.gl)
    this.refresh()
  }

  async refresh() {
    const width = 0.01;
    const color = this.color
    const paths: path.Path[] = [];
    for (const piece of this.area) {
      const p = new path.Path(piece.map((v) => new path.Point(v as any, color, width)), true, path.JOINT.MITER);
      paths.push(p);
    }
    this.setPaths(paths);
    this.globe.requestRefresh();
  }
}
